import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { OwnerState } from "./model";
import {Owner} from "@/store/modules/hcs/Model";

let state: OwnerState = {
  owners: new Map<string, Owner | Promise<Owner>>()
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<OwnerState, RootStateType>;
